import CacheObjects from './cache-objects';

export default class CacheSettings extends CacheObjects {
  constructor() {
    super('SETTINGS');
  }
}
